import httpRequestAdmin from "./httpRequest/httpRequestAdmin";

class LinkedinPromotionService {
  createDeal(body) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + "linkedin/promotion/deal/create", body);
  }

  updateDeal(id, body) {
    return httpRequestAdmin.put(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/deal/update/${id}`, body);
  }

  getDealByCompanyId(companyId) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/deal/${companyId}`);
  }

  getTotalStats() {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/deal/total-stats`);
  }
}

export default new LinkedinPromotionService();
